// Setor e chefe direto da pessoa (organograma funcional, 28/09/2026).
// Leitura para quem vê RH; edição só para o administrador do sistema
// (pessoa_organograma_salvar). O chefe direto recebe os alertas de horas.
import { useEffect, useMemo, useState } from 'react';
import { Button, Flex, Select, Tag, Typography, App as AntApp } from 'antd';
import { acaoPessoa, type Opcoes } from './apiPessoas';

const { Text } = Typography;

export default function OrganogramaCampos({ profissionalId, setorId, setorNome, chefeId, chefeNome, aoSalvar }: {
  profissionalId: string;
  setorId: string | null | undefined;
  setorNome: string | null | undefined;
  chefeId: string | null | undefined;
  chefeNome: string | null | undefined;
  aoSalvar: () => void;
}) {
  const { message } = AntApp.useApp();
  const [opcoes, setOpcoes] = useState<Opcoes | null>(null);
  const [editando, setEditando] = useState(false);
  const [setor, setSetor] = useState<string | undefined>(setorId || undefined);
  const [chefe, setChefe] = useState<string | undefined>(chefeId || undefined);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => { setSetor(setorId || undefined); setChefe(chefeId || undefined); }, [setorId, chefeId]);
  useEffect(() => {
    acaoPessoa<Opcoes>('pessoa_opcoes').then(setOpcoes).catch(() => setOpcoes(null));
  }, []);

  const setores = useMemo(() => (opcoes?.setores || []).filter((s) => s.ativo).map((s) => ({ value: s.id, label: s.nome })), [opcoes]);
  const chefes = useMemo(() => (opcoes?.chefes || []).filter((c) => c.id !== profissionalId)
    .map((c) => ({ value: c.id, label: `${c.nome}${c.setor ? ` · ${c.setor}` : ''}` })), [opcoes, profissionalId]);

  async function salvar() {
    setSalvando(true);
    try {
      await acaoPessoa('pessoa_organograma_salvar', { profissional_id: profissionalId, setor_id: setor || null, chefe_profissional_id: chefe || null });
      message.success('Organograma salvo.');
      setEditando(false); aoSalvar();
    } catch (e: any) { message.error(e.message, 8); }
    finally { setSalvando(false); }
  }

  async function novoSetor() {
    const nome = window.prompt('Nome do setor novo:');
    if (!nome) return;
    try {
      const r = await acaoPessoa<{ setor: { id: string } }>('pessoa_setor_salvar', { nome });
      setOpcoes(await acaoPessoa<Opcoes>('pessoa_opcoes')); setSetor(r.setor.id);
    } catch (e: any) { message.error(e.message); }
  }

  if (!editando) {
    return (
      <Flex gap={8} align="center" wrap>
        <Text style={{ fontSize: 12 }}><Text type="secondary">Setor:</Text> {setorNome || <Tag color="orange">sem setor</Tag>}</Text>
        <Text style={{ fontSize: 12 }}><Text type="secondary">Chefe direto:</Text> {chefeNome || <Tag color="orange">sem chefe</Tag>}</Text>
        {opcoes?.pode_ciclo && <Button size="small" type="link" onClick={() => setEditando(true)}>editar</Button>}
      </Flex>
    );
  }
  return (
    <Flex gap={8} align="center" wrap>
      <Select style={{ minWidth: 180 }} value={setor} onChange={setSetor} allowClear showSearch optionFilterProp="label" options={setores} placeholder="Setor" />
      <Button size="small" onClick={novoSetor}>+ setor</Button>
      <Select style={{ minWidth: 240 }} value={chefe} onChange={setChefe} allowClear showSearch optionFilterProp="label" options={chefes} placeholder="Chefe direto" />
      <Button size="small" type="primary" loading={salvando} onClick={salvar}>Salvar</Button>
      <Button size="small" onClick={() => setEditando(false)}>Cancelar</Button>
    </Flex>
  );
}
